// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--d5cb6";
export var body = "styles-module--body--9942b";
export var content = "styles-module--content--b05ca";
export var desktopOnly = "styles-module--desktopOnly--23122";
export var imageWrapper = "styles-module--imageWrapper--c92c0";
export var mobileOnly = "styles-module--mobileOnly--03528";
export var section = "styles-module--section--dfc98";
export var title = "styles-module--title--b2661";